(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('SesameAuthService', SesameAuthService);

  SesameAuthService.$inject = ['$resource'];

	 function SesameAuthService ($resource) {
    return $resource(apiUrl + '/sesame-mktzap/:id', { id: '@id' }, {
      validateHash: { url: apiUrl + '/sesame-mktzap/validate', method: 'POST', params: {}, isArray: false },
      sesameFirstLogin: { url: apiUrl + '/sesame-mktzap/first-login', method: 'POST', params: {}, isArray: false },
      generateSesameFirstAccessLink: { url: apiUrl + '/generate-sesame-access-link', method: 'GET', params: {}, isArray: false },
      getSesameLinks: { url: apiUrl + '/get-sesame-access-links', method: 'GET', params: {}, isArray: true },
      deleteSesameLink: { url: apiUrl + '/sesame-access-links', method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
